module.exports = __webpack_public_path__ + "static/media/2.5929ed97.jpg";